import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { API } from 'api';

export type RichTextSnippet = {
  name: string;
  template: string;
  placeholders: Record<string, string>;
};

export type UseReportSnippetsResult = Omit<
  UseQueryResult<RichTextSnippet[]>,
  'data'
> & {
  snippets: RichTextSnippet[];
  isLoading: boolean;
  isError: boolean;
};

const fetchReportSnippets = async (): Promise<RichTextSnippet[]> => {
  const response = await API.get('report_snippets');
  return response.data;
};

export const useReportSnippets = (): UseReportSnippetsResult => {
  const { data, ...result } = useQuery<RichTextSnippet[]>({
    queryKey: ['reportSnippets'],
    queryFn: () => fetchReportSnippets(),
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  return {
    snippets: data ?? [],
    ...result,
  };
};
